<template>
  <div class="slider">
    <div :class="['slider-tab', { active: activeTab === 'province' }]" :title="provinceName">
      {{ provinceName }}
    </div>
    <div :class="['slider-tab', { active: activeTab === 'city' }]">
      {{ cityName }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue';
import { useAreaContext } from '../context';

defineProps<{ activeTab: string }>()

const { model } = useAreaContext()!


const provinceName = computed(() => {
  if (model.province) return model.province.districtName
  return '省份'
})

const cityName = computed(() => {
  if (model.city) return model.city.districtName
  return '城市'
})

</script>

<style scoped>
.slider {
  width: 80px;
  height: 100%;
  background: #F7F8FA;
  flex-shrink: 0;
  height: 100%;
  margin-right: 16px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
}

.slider-tab {
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;

  cursor: pointer;
  padding: 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.slider-tab:hover:not(.active) {
  color: #7E51E4;
}

.slider-tab.active {
  background: #7E51E4;
  color: #fff;
}
</style>
